import { createVNode, render, h } from 'vue'
import { UiSlidePanel } from '~/javascript/components/ui/slide_panel'

const wrapper = document.createElement('div')
document.body.append(wrapper)

// Store the component instance
let componentInstance = null

// Create a wrapper component that captures the instance
const WrapperComponent = {
  setup() {
    return () => h(UiSlidePanel, {
      ref: (el) => {
        if (el) {
          componentInstance = el
        }
      }
    })
  }
}

const vnode = createVNode(WrapperComponent)
render(vnode, wrapper)

export default function useSlidePanel() {
  return {
    open: (...args) => componentInstance?.open(...args),
    close: () => componentInstance?.close()
  }
}
